import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'

export type Shop = {
	STORE_ID: string
	NAME: string
	XML_ID: string
	FULL_ADDRESS: string
	MALL: string
	METRO: string
	IS_STOCK: string
	IS_SHOP: string
	METRO_LINE: string
	PHONE: string
	TEXT_DESCRIPTION: string
	TEXT_INFO: string
	AMOUNT: string
	REGION: string
	SCHEDULE: string
	GPS_N: string
	GPS_S: string
	PRODUCT_ID: string
	SORT: string
	REGION_CODE: string
	DELIVERY_DATE: string
	IMAGES: string[]
	UF_IS_SERVICE?: string
	UF_IS_SHOP?: string
}

export const shopsApiSlice = apiSlice.injectEndpoints({
	endpoints: builder => ({
		shops: builder.query<ServerResponse<Shop[]>, void>({
			query: () => '/shops'
		})
	})
})

export const { useShopsQuery } = shopsApiSlice
